import { render, staticRenderFns } from "./QuoteFormInfo.vue?vue&type=template&id=31ce91ce&scoped=true&"
import script from "./QuoteFormInfo.vue?vue&type=script&lang=ts&"
export * from "./QuoteFormInfo.vue?vue&type=script&lang=ts&"
import style0 from "./QuoteFormInfo.vue?vue&type=style&index=0&id=31ce91ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ce91ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
